import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import GroupsTable from "../../../containers/admin/groups/table";
import SearchBar from "../../../containers/admin/groups/searchbar";
import { getAllGroupsRequest } from "../../../modules/admin-modules/groups/Actions";
import AddGroup from "../../../containers/admin/groups/models/add-group";
import { useSuperAdminSubjectFilter } from "../../../helpers/useSuperAdminSubjectFilter";

const Groups = () => {
  const dispatch = useDispatch();
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const {
    isSuperAdmin,
    selectedSubjectId,
    setSelectedSubjectId,
    subjectQuery,
    canFetch,
  } = useSuperAdminSubjectFilter();

  useEffect(() => {
    if (!canFetch) return;
    dispatch(getAllGroupsRequest(subjectQuery));
  }, [canFetch, selectedSubjectId, dispatch]);

  return (
    <Layout>
      <SearchBar
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        isSuperAdmin={isSuperAdmin}
        selectedSubjectId={selectedSubjectId}
        setSelectedSubjectId={setSelectedSubjectId}
      />
      <GroupsTable
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        hideList={isSuperAdmin && !selectedSubjectId}
      />
      <AddGroup
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
      />
    </Layout>
  );
};

export default Groups;
